import React from "react";
import CompleteSignup from "../auth/CompleteSignup";

export default function CompleteSignUpPage() {
  return <CompleteSignup />;
}
